import Pagination from '@mui/material/Pagination';
import { Select } from '@core/design-system/input';

const SELECT_OPTIONS = [
  { value: 10, label: '10' },
  { value: 25, label: '25' },
  { value: 50, label: '50' },
  { value: 100, label: '100' },
  { value: 500, label: '500' },
];

export const withPagination =
  (Component: React.FC) => (props: IPaginationProps) => {
    if (!props.page) return <Component {...(props as any)} />;

    return (
      <>
        <Component {...(props as any)} />
        {props?.cardFooter}

        <div className="flex justify-center items-center gap-1 mt-2 flex-wrap">
          <Pagination
            count={props.countPages}
            page={props.page}
            onChange={(event, newPage) =>
              props?.onPageChange && props?.onPageChange(newPage)
            }
            sx={{
              ['& .MuiPaginationItem-root']: {
                borderRadius: 1,
              },
            }}
            color="secondary"
          />
          <Select
            defaultValue={props?.pageSize || 10}
            onChange={(value) => {
              props?.onPageSizeChange &&
                props?.onPageSizeChange(Number(value.target.value));
            }}
            options={SELECT_OPTIONS}
            sx={{
              minWidth: 70,
              width: 80,
              ['& .MuiInputBase-input']: {
                padding: '4px 8px',
                texAlign: 'center',
              },
            }}
          />

          <p className="leading-4">por página</p>
        </div>
      </>
    );
  };

export interface IPaginationProps {
  page?: number;
  pageSize?: number;
  countPages?: number;
  onPageChange?: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
  cardFooter?: React.ReactNode;
}
